export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8758.265d63e9.jpg";